import React from 'react';
import { DataSearch } from '@appbaseio/reactivesearch';
import { Icon } from 'antd';
import styled from '@emotion/styled';

const StyledSearch = styled(DataSearch)`
	width: 100%;
	input {
		width: 100%;
	}
`;

const GlobalSearch = () => (
	<StyledSearch
		componentId="GlobalSearch"
		autosuggest={false}
		dataField={[
			'genres',
			'genres.autosuggest',
			'genres.keyword',
			'genres.search',
			'original_title',
			'original_title.autosuggest',
			'original_title.keyword',
			'original_title.search',
			'overview',
			'overview.autosuggest',
			'overview.keyword',
			'overview.search',
		]}
		debounce={5}
		queryFormat="and"
		highlight={true}
		highlightField={[
			'genres',
			'genres.autosuggest',
			'genres.keyword',
			'genres.search',
			'original_title',
			'original_title.autosuggest',
			'original_title.keyword',
			'original_title.search',
			'overview',
			'overview.autosuggest',
			'overview.keyword',
			'overview.search',
		]}
		icon={<Icon type="search" style={{ position: 'absolute' }} />}
	/>
);

export default GlobalSearch;
